import { useCallback, useEffect, useState } from 'react'
import {
  Backdrop,
  CircularProgress,
  Grid,
  makeStyles,
  Button,
  Typography,
  Divider
} from '@material-ui/core'
import { getModifiedProduct } from '../../../api/productModification.service'
import SaveOrCancelButtons from '../../../components/saveOrCancelButtons'
import DownloadIcon from '@material-ui/icons/GetApp'
import imgNotFound from '../../../assets/img/imagen_no_disponible.jpeg'
import { DialogTitle } from '../../../components/DialogTitle'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  title: {
    justifySelf: 'end',
    margin: '-5px 15px 20px 5px'
  },
  rowTitle: {
    marginRight: 8,
    marginBottom: 4,
    fontWeight: 'bold',
    fontSize: 14
  },
  rowText: {
    fontSize: 18,
    maxWidth: 280
  },
  commentContainer: {
    border: 'solid 1.5px #ff1744',
    backgroundColor: '#efefef',
    borderRadius: '10px',
    margin: '15px 0px',
    padding: '10px'
  },
  imagePreview: {
    maxWidth: '300px',
    maxHeight: '300px',
    minWidth: '250px',
    minHeight: '250px',
    objectFit: 'contain'
  }
}))

const ProductDetails = (props) => {
  const classes = useStyles()

  const productId = props.id
  const handleClose = props.onClose

  const [loading, setLoading] = useState(false)

  const [stateForm, setStateForm] = useState({})

  const getData = useCallback(() => {
    setLoading(true)
    getModifiedProduct(productId).then(({ data }) => {
      setStateForm(data)
      setLoading(false)
    })
  }, [productId])

  useEffect(() => {
    if (productId !== undefined && productId !== null) {
      getData()
    }
  }, [productId, getData])

  const isEmpty = (value) => {
    return !value || value === null || value === ''
  }

  const Title = (_) => <h2>Detalle de la Modificación:</h2>

  return (
    <div>
      <Grid container direction="column">
        <DialogTitle title={<Title />} />
        <Grid item>
          <Grid container direction="row" spacing={3}>
            {stateForm.state === 'RevisionProveedor' && (
              <Grid item xs={12} className={classes.commentContainer}>
                <div className={classes.rowTitle}>Comentario: </div>
                <div>{stateForm.comments}</div>
              </Grid>
            )}
            <Grid item xs={12} md={5}>
              <Typography>IMAGEN DE ARTÍCULO</Typography>
              <Divider className="mb-2" />
              {!isEmpty(stateForm.urlImage) ? (
                <img
                  className={classes.imagePreview + ' d-flex mx-auto'}
                  alt={`img-product-${stateForm.id}`}
                  src={stateForm.urlImage}
                  onError={(event) => {
                    event.currentTarget.onerror = null
                    event.currentTarget.src = imgNotFound
                  }}
                />
              ) : (
                <img
                  className={classes.imagePreview + ' d-flex mx-auto'}
                  alt={`img-product-${stateForm.id}`}
                  src={imgNotFound}
                  onError={(event) => {
                    event.currentTarget.onerror = null
                    event.currentTarget.src = imgNotFound
                  }}
                />
              )}
            </Grid>
            <Grid item xs={12} md={7}>
              <Grid container direction="row" spacing={2}>
                <Grid item xs={12}>
                  <Typography>FICHA DEL ARTÍCULO</Typography>
                  <Divider className="mb-2" />
                  <Button
                    variant="contained"
                    size="small"
                    component="a"
                    disabled={isEmpty(stateForm.urlProductCard)}
                    href={stateForm.urlProductCard}
                    target="_blank"
                    fullWidth
                    startIcon={<DownloadIcon fontSize={'small'} />}
                  >
                    Ficha de producto
                  </Button>
                </Grid>
                <Grid item xs={12}>
                  <Typography>DOCUMENTOS DEL ARTÍCULO</Typography>
                  <Divider className="mb-2" />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    size="small"
                    component="a"
                    disabled={isEmpty(stateForm.urlLabel)}
                    href={stateForm.urlLabel}
                    target="_blank"
                    fullWidth
                    startIcon={<DownloadIcon fontSize={'small'} />}
                  >
                    Etiqueta
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    size="small"
                    component="a"
                    disabled={isEmpty(stateForm.urlSecurityCard)}
                    href={stateForm.urlSecurityCard}
                    target="_blank"
                    fullWidth
                    startIcon={<DownloadIcon fontSize={'small'} />}
                  >
                    Ficha de Seguridad
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    size="small"
                    component="a"
                    disabled={isEmpty(stateForm.urlGreenPoint)}
                    href={stateForm.urlGreenPoint}
                    target="_blank"
                    fullWidth
                    startIcon={<DownloadIcon fontSize={'small'} />}
                  >
                    Punto Verde
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    size="small"
                    component="a"
                    disabled={isEmpty(stateForm.urlSugar)}
                    href={stateForm.urlSugar}
                    target="_blank"
                    fullWidth
                    startIcon={<DownloadIcon fontSize={'small'} />}
                  >
                    Azúcar
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    size="small"
                    component="a"
                    disabled={isEmpty(stateForm.urlAdditional1)}
                    href={stateForm.urlAdditional1}
                    target="_blank"
                    fullWidth
                    startIcon={<DownloadIcon fontSize={'small'} />}
                  >
                    Otro 1
                  </Button>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Button
                    variant="contained"
                    size="small"
                    component="a"
                    disabled={isEmpty(stateForm.urlAdditional2)}
                    href={stateForm.urlAdditional2}
                    target="_blank"
                    fullWidth
                    startIcon={<DownloadIcon fontSize={'small'} />}
                  >
                    Otro 2
                  </Button>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography className="text-uppercase">Comentario</Typography>
              <Divider className="mb-2" />
              <Typography variant="body2" color="primary">
                {isEmpty(stateForm.changeDescripcion) ? '--' : stateForm.changeDescripcion}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography className="text-uppercase">Información adicional</Typography>
              <Divider className="mb-2" />
              <Typography variant="body2" color="primary">
                {isEmpty(stateForm.additionalInfo) ? '--' : stateForm.additionalInfo}
              </Typography>
            </Grid>
            <Grid item xs={12} md={4}>
              <Typography className="text-uppercase">Video url</Typography>
              <Divider className="mb-2" />
              <Typography variant="body2" component="a" href={stateForm.videoUrl} color="primary">
                {isEmpty(stateForm.videoUrl) ? '--' : stateForm.videoUrl}
              </Typography>
            </Grid>
          </Grid>
          <SaveOrCancelButtons onSave={false} onCancel={handleClose} loading={loading} />
        </Grid>
      </Grid>
      <Backdrop className={classes.backdrop} open={loading} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default ProductDetails
